import { useQuery } from "@tanstack/react-query";
import { listRecordingFrames } from "proto/recording/v1/recording_api-RecordingAPI_connectquery";

export const useGetFrames = (id: string) => {
  const { isLoading, isFetching, isError, error, data } = useQuery(
    listRecordingFrames.useQuery({ recordingId: id })
  );
  return { isLoading, isFetching, isError, error, data };
};
